const voice = () => ({
  parentNav: 'voice',
  routes: ['voice_teaser'],
  menuItems: [],
});

export default voice;
